import { Dispatch, SetStateAction } from 'react';
import { calculateDifference, calculateTotals, getComparisonFilterString } from '.';
import { useQuery } from '@tanstack/react-query';
import { getSalesOrders } from 'src/services/salesorder';

interface UseCostComparisonQueries {
  orderByValue: string;
  requiredRange?: string;
  initialAverage: string;
  setDifferenceValue: Dispatch<SetStateAction<number>>;
  setPercentageChange: Dispatch<SetStateAction<number>>;
}

export default ({
  orderByValue,
  requiredRange,
  initialAverage,
  setDifferenceValue,
  setPercentageChange
}: UseCostComparisonQueries) => {
  const { data } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['costPerPalletSpaceComparison', requiredRange],
    queryFn: async () => {
      const res = await getSalesOrders({ filter: getComparisonFilterString(orderByValue, requiredRange ?? '') });

      return res.data;
    },
    enabled: Boolean(requiredRange),
    onSuccess: (data: any[]) => {
      const { average } = calculateTotals(data);
      const { difference, percentage } = calculateDifference(initialAverage, average);

      setDifferenceValue(difference);
      setPercentageChange(percentage);
    }
  });

  return { data };
};
